import HeadLine from "./HeadLine";
import Question from "./Question";
const secreenTypes = {
  HeadLine,
  Question,
};
export default secreenTypes;
